var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"visit",attrs:{"title":"nombre de visite"}},[_vm._v(_vm._s(_vm.visit))])}
var staticRenderFns = []

export { render, staticRenderFns }